import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IProductModel } from '@apps-common/types/management/product'

export const MANAGEMENT_QUERY_KEY_GET_PRODUCT = (id?: string) => ['getManagementProduct', id].filter(Boolean)

export const getProduct = async (productId: string): Promise<IProductModel> =>
  axios.get(`/management/product/getproduct?productId=${productId}`).then((res) => res.data?.data)

type QueryFnType = typeof getProduct

type Props = {
  config?: QueryConfig<QueryFnType>
  productId: string
}

export const useManagementGetProduct = ({ config, productId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_GET_PRODUCT(productId),
    queryFn: () => getProduct(productId)
  })
